import React from 'react';

function Header() {
    return (
        <>
        <div className='footer' id='footer-link'>
            <ul className='li-style'>
            <li className='footer-li'>FAQ</li>
            <li className='footer-li'>Investor Relations</li>
            <li className='footer-li'>Privacy</li>
            <li className='footer-li'>Speed Test</li>
            </ul>
            <ul className='li-style'>
            <li className='footer-li'>Help Centre</li>
            <li className='footer-li'>Jobs</li>
            <li className='footer-li'>Cookie Preferences</li>
            <li className='footer-li'>Legal Notices</li>
            </ul>
            <ul className='li-style'>
            <li className='footer-li'>Account</li>
            <li className='footer-li'>Ways to Watch</li>
            <li className='footer-li'>Corporate Information</li>
            <li className='footer-li'>Only on Netflix</li>
            </ul>
            <ul className='li-style'>
            <li className='footer-li'>Media Centre</li>
            <li className='footer-li'>Terms of Use</li>
            <li className='footer-li'>Contact Us</li>
            </ul>
        </div>
        <br/>
        <div className='copyright'>
        <p className="text-center">Netflix Clone App | &copy; <a href="https://chrisbin95.github.io/Portfolio/" target="_blank">Chrisbin Thomas</a></p></div>
        </>
    );
}

export default Header;
